var window=global;var $CLJS=require("./cljs_env");require("./goog.base.js");
$CLJS.vz=require("ttag");module.exports=$CLJS.vz;